import { BaseAPIClient } from '@mi-front/core';
import { MinimumStationsGroup, Station } from '../core/types/stations';

/** API methods for loading and updating stations in the main application. */
export const StationsAPI = {
  fetchAll(this: BaseAPIClient): Promise<Station[]> {
    return this.get('/stations');
  },

  save(this: BaseAPIClient, idOrSlug: string, data: Partial<Station>): Promise<Station> {
    return this.put<Station>(`/stations/${idOrSlug}`, data);
  },

  fetchStationGroupsForStation(
    this: BaseAPIClient,
    idOrSlug: string,
  ): Promise<MinimumStationsGroup[]> {
    return this.get(`/stations-groups/stations/${idOrSlug}`);
  },

  fetchAllStationGroups(this: BaseAPIClient): Promise<MinimumStationsGroup[]> {
    return this.get('/stations-groups');
  },
};
